import React from 'react';
import { Link } from 'gatsby';
import { toTitleCase } from '../lib/helpers/string-helper';
function breadCrumblink(paths, index) {
    var link = '';
    var pathIndex = index;
    paths.map(function (p, index) {
        if (index === pathIndex) {
            return link += "/" + p + "/";
        }
        else if (index > pathIndex) {
            return;
        }
        else {
            return link += "/" + p + "/";
        }
    });
    link = link.replace(/\/\//g, '/');
    return link;
}
function renderBreadcrumbs(props) {
    if (!props.path.location)
        return;
    var currentPath = props.path.location.pathname;
    var paths = currentPath.replace(/\//g, ' ');
    var pathsToArray = paths.split(' ').filter(function (s) {
        return !!s.length;
    });
    var pathNoSlugs = pathsToArray.map(function (path) {
        return path.replace(/-/g, ' ');
    });
    return pathNoSlugs.map(function (path, index) {
        return /*#__PURE__*/ React.createElement("li", {
            key: path
        }, /*#__PURE__*/ React.createElement(Link, {
            className: "breadcrumbs__link",
            to: breadCrumblink(pathsToArray, index),
            activeClassName: "breadcrumbs__link--active"
        }, toTitleCase(path)));
    });
}
var Breadcrumbs = function Breadcrumbs(props) {
    return /*#__PURE__*/ React.createElement("ol", {
        className: "breadcrumbs"
    }, /*#__PURE__*/ React.createElement("li", null, /*#__PURE__*/ React.createElement(Link, {
        className: "breadcrumbs__link",
        to: '/'
    }, "Home")), renderBreadcrumbs(props));
};
export default Breadcrumbs;
